export default {
  title: '广告层级管理',
  menu: '广告层级管理',
  label: {
    adsTierOne: '广告层级 ： 1',
    adsTierTwo: '广告层级 ： 2'
  },
  placeholder: {
  },
  message: {
    saveSuccess: '保存广告位顺序成功。'
  }
}
